'use strict';

require('../../style/index.less');

require('../../popover/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/popconfirm/style/index.js
 ** module id = 261
 ** module chunks = 0
 **/